<template>
  <div class="relative">
    <!--<a href="">Download All</a>-->
    <Popper
      v-cloak
      ref="popper"
      trigger="click"
      :options="{}"
    >
      <div class="popper popper-simple popper-arrow">
        <div class="max-w-md flex flex-col">
          <div class="flex flex-col text-left">
            <a
              href="#"
              @click.prevent="openSendToMembershipGroupsModal"
              v-text="'Share with Groups'"
            />
            <a
              href="#"
              @click.prevent="openSendToMembershipsModal"
              v-text="'Share with Members'"
            />
            <a
              :href="editMemberVisibilityUrl"
              v-text="'Edit Members'"
            />
          </div>
        </div>
      </div>
      <a
        slot="reference"
        class="btn btn--sm btn--icon-only icon icon--small"
        href="#"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9"
          height="15"
          viewBox="0 0 9 15"
        >
          <path d="M7.67 2.48l.66-1.23L6.25.21 5.56 1.5zm-2.35-.54L.48 10.95l2.11.98 4.84-9.01zM.31 11.43L.1 14.11l2.21-1.75z" />
        </svg>
      </a>
    </Popper>
  </div>
</template>

<script type="text/babel">
import Popper from 'vue-popperjs'

export default {
  name: 'SharedFolderActions',
  components: {
    Popper,
  },
  props: {
    folder: {
      type: Object,
      required: true,
    },
  },
  computed: {
    editMemberVisibilityUrl() {
      return this.$urlGenerator.active(`documents/shares/folders/${this.folder.uuid}/visibilities`)
    },
  },
  methods: {
    hidePopper() {
      this.$refs.popper.showPopper = false
    },
    openSendToMembershipsModal() {
      this.$store.commit('documentOpenSendToMembershipsModal', this.folder)

      this.hidePopper()
    },
    openSendToMembershipGroupsModal() {
      this.$store.commit('documentOpenSendToMembershipGroupsModal', this.folder)

      this.hidePopper()
    },
  },
}
</script>
